import * as f from "react";
function o(r) {
  return f.forwardRef(r);
}
export {
  o as forwardRefWithAs
};
